<div class="page-header"  [class.original-header]="!isScrolled" [class.sticky-header]="isScrolled" >
    <ng-content></ng-content>
</div>